import { messages as anniversaries } from '@features/anniversaries/i18n/zh-CN'
import { messages as bodymetrics } from '@features/bodymetrics/i18n/zh-CN'
import { messages as calendar } from '@features/calendar/i18n/zh-CN'
import { messages as chat } from '@features/chat/i18n/zh-CN'
import { messages as comments } from '@features/comments/i18n/zh-CN'
import { messages as diary } from '@features/diary/i18n/zh-CN'
import { messages as memo } from '@features/memo/i18n/zh-CN'
import { messages as misc } from '@features/misc/i18n/zh-CN'
import { messages as notifications } from '@features/notifications/i18n/zh-CN'
import { messages as packing } from '@features/packing/i18n/zh-CN'
import { messages as schedule } from '@features/schedule/i18n/zh-CN'
import { messages as strength } from '@features/strength/i18n/zh-CN'
import { messages as todo } from '@features/todo/i18n/zh-CN'
import { messages as travel } from '@features/travel/i18n/zh-CN'

export default {
  anniversaries,
  bodymetrics,
  calendar,
  chat,
  comments,
  diary,
  memo,
  misc,
  notifications,
  packing,
  schedule,
  strength,
  todo,
  travel
}
